module.exports = __webpack_public_path__ + "images/interior-3d-1-bbd44c6e56479ce2dd6d200173eef338.jpg";